import React from 'react';
import DatabaseProvider from '@nozbe/watermelondb/DatabaseProvider';

import database from './database';

const Database: React.FC = ({ children }) => {
  // @ts-ignore
  return <DatabaseProvider database={database}>{children}</DatabaseProvider>;
};

export default Database;
